import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { ADJUST_PAYMENT_SCHEDULE, FETCH_PAYMENT_SCHEDULE, FETCH_DYNAMIC_PAYMENT_SCHEDULE } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialPaymentScheduleState: App.PaymentScheduleState = {
  fetchingCharges: {},
  charges: {},
  fetchingAdjustedCharges: {},
  adjustedCharges: {},
  fetchingDynamicCharges: {},
  dynamicCharges: {},
}

const apiCalls = apiReducerSwitch<App.PaymentScheduleState>({
  [FETCH_PAYMENT_SCHEDULE]: {
    request: (state, action) => ({
      ...state,
      fetchingCharges: {
        ...state.fetchingCharges,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      ...state,
      fetchingCharges: {
        ...state.fetchingCharges,
        [action.key]: false,
      },
      charges: {
        ...state.charges,
        [action.key]: {
          charges: action.data.charges,
          eligible: action.data.eligible,
          ineligibilityReason: action.data.ineligibilityReason,
        },
      },
    }),
    failure: (state, action) => ({
      ...state,
      fetchingCharges: {
        ...state.fetchingCharges,
        [action.key]: false,
      },
    }),
  },
  [ADJUST_PAYMENT_SCHEDULE]: {
    request: (state, action) => ({
      ...state,
      fetchingAdjustedCharges: {
        ...state.fetchingAdjustedCharges,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      ...state,
      fetchingAdjustedCharges: {
        ...state.fetchingAdjustedCharges,
        [action.key]: false,
      },
      adjustedCharges: {
        ...state.adjustedCharges,
        [action.key]: {
          charges: action.data.adjustedCharges,
          summary: action.data.adjustedSummary,
          eligible: action.data.eligible,
          isDynamicTemplate: action.data.isDynamicTemplate,
          frequency: action.data.frequency,
        },
      },
    }),
    failure: (state, action) => ({
      ...state,
      fetchingAdjustedCharges: {
        ...state.fetchingAdjustedCharges,
        [action.key]: false,
      },
    }),
  },
  [FETCH_DYNAMIC_PAYMENT_SCHEDULE]: {
    request: (state, action) => ({
      ...state,
      fetchingDynamicCharges: {
        ...state.fetchingDynamicCharges,
        [action.key]: true,
      },
    }),
    success: (state, action) => ({
      ...state,
      fetchingDynamicCharges: {
        ...state.fetchingDynamicCharges,
        [action.key]: false,
      },
      dynamicCharges: {
        ...state.dynamicCharges,
        [action.key]: {
          dynamicPaymentScheduleOptions: action.data.dynamicPaymentScheduleOptions,
          initialPaymentSchedule: action.data.initialPaymentSchedule,
          eligible: action.data.eligible,
          ineligibilityReason: action.data.ineligibilityReason,
        },
      },
    }),
    failure: (state, action) => ({
      ...state,
      fetchingDynamicCharges: {
        ...state.fetchingDynamicCharges,
        [action.key]: false,
      },
    }),
  },
})

const paymentScheduleReducer = createAppReducer<App.PaymentScheduleState>(initialPaymentScheduleState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})

export default paymentScheduleReducer
